import { withStyles, Button } from "@material-ui/core";
import { isReadOnlyPickupViewMode } from "../../../utils";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import { getShipmentsParameterCount } from "../../utils";

const styles = (theme) => ({
  container: {
    marginTop: 12,
    display: "flex",
    border: `1px solid ${theme.AppBGColor}`,
    borderRadius: "4px",
    flexWrap: "wrap",
    justifyContent: "space-between",
    padding: 8,
    alignItems: "center"
  },
  label: {
    fontSize: theme.textFontSize,
    fontWeight: 400,
    color: theme.dispatchPanelHeaderColor,
    marginRight: 4,
  },
  value: {
    fontSize: theme.textFontSize,
    fontWeight: 600,
    color: theme.TextColor,
  },
  addShipmentButton: {
    color: theme.HeaderSelectedText,
    backgroundColor: "transparent",
    boxShadow: "none",
    fontWeight: 600,
    letterSpacing: "1px",
    "&:hover": {
      backgroundColor: theme.btnHoverColor,
    },
    "&:focus": {
      backgroundColor: theme.btnHoverColor,
    },
    "&:disabled": {
      color: theme.disabledColor,
    },
  },
  removeShipmentButton: {
    color: theme.ErrorMessageColor,
    backgroundColor: "transparent",
    boxShadow: "none",
    fontWeight: 600,
    letterSpacing: "1px",
    "&:hover": {
      backgroundColor: theme.btnHoverColor,
    },
    "&:focus": {
      backgroundColor: theme.btnHoverColor,
    },
    "&:disabled": {
      color: theme.disabledColor,
    },
  }
});

const FooterDetails = ({
  classes,
  data,
  mode,
  onAddRow,
  onRemoveRow,
  disableAddRow,
  disableRemoveRow,
  hideAddRow,
}) => {
  const { totalShipments, totalWeight, totalPieces } =
    getShipmentsParameterCount(data);
  return (
    <div className={classes.container}>
      <div className={classes.value}>
        Total
      </div>
      <div>
        <span className={classes.label}>{"Shipment(s):"}</span>
        <span className={classes.value}>{totalShipments}</span>
      </div>
      <div>
        <span className={classes.label}>{"Piece(s):"}</span>
        <span className={classes.value}>{totalPieces}</span>
      </div>
      <div>
        <span className={classes.label}>Weight:</span>
        <span className={classes.value}>{totalWeight}</span>
      </div>
      {!isReadOnlyPickupViewMode(mode) && (
          <div>
            {!hideAddRow && (
              <Button
                variant="text"
                color="primary"
                onClick={onAddRow}
                id="addNewShipment"
                size="small"
                disabled={disableAddRow}
                className={classes.addShipmentButton}
                disableRipple
              >
                + Add Shipment
              </Button>
            )}
            <Button
              variant="text"
              color="primary"
              onClick={onRemoveRow}
              id="onRemoveRow"
              size="small"
              disabled={disableRemoveRow}
              className={classes.removeShipmentButton}
              disableRipple
            >
              <DeleteOutlineIcon className={classes.iconStyle} /> Remove
            </Button>
          </div>
      )}
    </div>
  );
};

export default withStyles(styles)(FooterDetails);
